/**
 * Global state for Alpine components.
 */
import experienceResultsConfig from '../config/experienceResults.js';

export default function global() {
    return {
        quizScore         : 0,
        totalQuestions    : 0,
        resultPercentage  : 0,
        resultTitle       : '',
        resultDescription : '',
        resultImageSrc    : '',
        resultImageAlt    : '',

        updateResults() {
            if (!this.totalQuestions) {
                this.resultPercentage = 0;
            } else {
                const rawPercentage = (this.quizScore / this.totalQuestions) * 100;

                this.resultPercentage = Math.round(rawPercentage);
            }

            const groups        = experienceResultsConfig.groups || [];
            const { defaultGroupId } = experienceResultsConfig;
            const percentage     = this.resultPercentage;

            let activeGroup = groups.find((group) => percentage >= group.minPercentage
                && percentage <= group.maxPercentage);

            if (!activeGroup && defaultGroupId) {
                activeGroup = groups.find((group) => group.id === defaultGroupId) || groups[0];
            }

            if (!activeGroup && groups.length === 0) {
                this.resultTitle       = '';
                this.resultDescription = '';
                this.resultImageSrc    = '';
                this.resultImageAlt    = '';

                return;
            }

            const safeGroup = activeGroup || groups[0];

            this.resultTitle       = safeGroup.title || '';
            this.resultDescription = safeGroup.description || '';
            this.resultImageSrc    = safeGroup.image && safeGroup.image.src ? safeGroup.image.src : '';
            this.resultImageAlt    = safeGroup.image && safeGroup.image.alt ? safeGroup.image.alt : '';

            this.$nextTick(() => {
                const scrollElement = document.querySelector('.experience-summary__inner .experience-summary__scroll[data-simplebar]');

                if (!scrollElement) {
                    return;
                }

                if (typeof window === 'undefined' || !window.SimpleBar || !window.SimpleBar.instances) {
                    return;
                }

                const instance = window.SimpleBar.instances.get(scrollElement);
                if (!instance || typeof instance.recalculate !== 'function') {
                    return;
                }

                instance.recalculate();
            });
        },

        init() {
            window.addEventListener('experience-quiz:overlay-shown', (event) => {
                const detail = event.detail || {};

                this.totalQuestions += 1;

                if (detail.isCorrect) {
                    this.quizScore += 1;
                }

                this.updateResults();
            });
        }
    };
}
